import axios from 'axios';
import { setSession, clearSession } from '../../utils/appUtils';
import { ADMIN_LOGIN } from '../../constants';

export const loginAdmin = (adminData, navigate, onError) => (dispatch) => {
  dispatch(loadAdminLogin());
  axios
    .post('auth/adminLogin', adminData)
    .then((res) => {
      const { name, email, role } = res.data.data;
      setSession(res.data.data);
      navigate('/dashboard/user');
      dispatch(setAdminLogin({ name, email, role }));
    })
    .catch((err) => {
      dispatch(errorAdminLogin(err.response));
      onError(err.response);
    });
};

export const loadAdminLogin = () => ({
  type: ADMIN_LOGIN.LOAD
});

export const setAdminLogin = (data) => ({
  type: ADMIN_LOGIN.SUCCESS,
  payload: data
});

export const errorAdminLogin = (error) => ({
  type: ADMIN_LOGIN.FAIL,
  payload: error
});

export const logoutAdmin = (navigate) => (dispatch) => {
  const done = () => {
    dispatch(errorAdminLogin({}));
    clearSession();
    dispatch(setAdminLogin({}));
    if (navigate) navigate('/login');
  };
  // ends the session on the server and clears the login cookie
  return axios.post('auth/logout').then(done, done);
};
